export default __webpack_public_path__ + "static/media/on_6.ad29fd85.mp3";